import { AfterViewChecked, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { AppTokenHandler, HTTPStatus } from 'src/app/CommonService/app-token-handler';
import { GlobalVariables } from 'src/app/GlobalVariables';
import { MediaMatcher } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { MatMenuTrigger } from '@angular/material/menu';
import { DOCUMENT } from '@angular/common'; 
import { Inject }  from '@angular/core';
import {  Renderer2 } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { DataService } from 'src/app/CommonService/data.service';
import saveAs from 'file-saver';

enum Roles {
  Admin = 1,
  TQApprover = 2,
  EngTeam = 3,
  TQLeader = 4,
}
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit ,AfterViewChecked{
  mobileQuery: MediaQueryList;
  User: any = [];
  old:any;
  mod:any;
  textToCompare1!: string;
  textToCompare2!: string;
  highlightedText!: string;
  modifiedText!: string;
  title = 'InTaxGTC';
  UserName!: string;
  IsLoadingResults: any;
  UserImage!: string;
  UserRole!: string;
  panelOpenState = false;
  panelOpenStateForSideNav = false;
  panelOpenStateForLogout = false;
  iSLoading!: boolean;
  Admin: any;
  Year: number = new Date().getFullYear();
  isDashboardVisiblity! : boolean;
  userDetails: any;
  isToolGuideDownloading = false;
  private _mobileQueryListener: () => void;
  document: any;
  sanitizedHTMLContent: any;
  constructor(private appToken: AppTokenHandler, media: MediaMatcher
    , changeDetectorRef: ChangeDetectorRef, private route: Router,
    private sanitizer: DomSanitizer,
    private httpStatus: HTTPStatus,
    private cdRef: ChangeDetectorRef,
    private renderer: Renderer2, private elementRef: ElementRef,
    private dataService: DataService,
    public _global: GlobalVariables, @Inject(DOCUMENT) document: Document) {
    //this.UserName = appToken.getLoginUserInfo().EmpName;
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
   
  }
 

  // compareText() {
  //   const words1 = this.textToCompare1.split(' ');
  //   const words2 = this.textToCompare2.split(' ');

  //   let modifiedHighlightedText = '';

  //   const maxLength = Math.max(words1.length, words2.length);

  //   for (let i = 0; i < maxLength; i++) {
  //     const word1 = words1[i] || '';
  //     const word2 = words2[i] || '';

  //     if (word1 === word2) {
  //       modifiedHighlightedText += word2 + ' ';
  //     } else {
  //       modifiedHighlightedText +=
  //         '<del class="CompareDelete">' +
  //         word1 +
  //         '</del>' +
  //         '<span class="CompareAdd">' +
  //         word2 +
  //         '</span> ';
  //     }
  //   }

  //   this.modifiedText = modifiedHighlightedText.trim();
  // }
  // compareText() {
  //    const differences: string[] = [];
  //   const text1 = this.textToCompare1.split(' ');
  //   const text2 = this.textToCompare2.split(' ');
  //   const element = this.elementRef.nativeElement.querySelector('#modifiedText');
    
  //   const text3 = this.textToCompare1;
  //   const text4 = this.textToCompare2;
  //   for (let i = 0; i < text2.length; i++) {
  //     if (text1[i] !== text2[i]) {
  //       differences.push(`<span class="CompareAdd">${text2[i]}</span>`);
  //     } else {
  //       differences.push(`<del class="CompareDelete">${text1[i]}</del>`);

        
  //     }
  //   }

  //   this.modifiedText = differences.join(' ');
  //   // Compare the texts and get the modified text with highlighted differences
  //   this.highlightedText = this.getModifiedText(text3, text4);
  // }

  // getModifiedText(text1: string, text2: string): string {
  //   const words1 = text1.split(' ');
  //   const words2 = text2.split(' ');

  //   let modifiedText = '';

  //   const maxLength = Math.max(words1.length, words2.length);

  //   for (let i = 0; i < maxLength; i++) {
  //     const word1 = words1[i] || '';
  //     const word2 = words2[i] || '';

  //     if (word1 === word2) {
  //       // If the words are the same, add it without highlighting
  //       modifiedText += word2 + ' ';
  //     }
  //      else {
  //       const diffIndex = this.getDifferenceIndex(word1, word2);

  //       if (diffIndex === -1) {
  //         // If one word is completely contained within the other, add the longer word without highlighting
  //         if (word1.length > word2.length) {
  //           modifiedText += word1 + ' ';
  //         } else {
  //           modifiedText += word2 + ' ';
  //         }
  //       } else {
  //         // If the words have a difference, highlight the difference
  //         modifiedText +=
  //           word1.substring(0, diffIndex) +
  //           '<del class="CompareDelete">' +
  //           word1.substring(diffIndex) +
  //           '</del>' +
  //           ' ';
  //       }
  //     }

      
  //   }

  //   return modifiedText.trim();
  // }

  // getDifferenceIndex(word1: string, word2: string): number {
  //   const minLength = Math.max(word1.length, word2.length);

  //   for (let i = 0; i < minLength; i++) {
  //     if (word1.charAt(i) !== word2.charAt(i)) {
  //       return i;
  //     }
  //   }

  //   return -1;
  // }
  ngAfterViewChecked() {
    this.httpStatus.getHttpStatus().subscribe((status: boolean) => {
      this.iSLoading = status;
    });
    var currentPage = this.route.url;
    if(currentPage  == '/home'){
      this.isDashboardVisiblity = true;
    }
    else{
      this.isDashboardVisiblity = false;

    }
    this.cdRef.detectChanges();
  }
  downloadPdf() {
    if (this.isToolGuideDownloading) {
      return;
    }

    this.isToolGuideDownloading = true;
    this.dataService.DownloadFile('TaxGTC/DownloadGTCToolGuide').subscribe({
      next: (file: any) => saveAs(file, 'GTC Tool Guide.pdf'),
      error: (error: any) => {
        this.isToolGuideDownloading = false;
        console.error('GTC Tool Guide download failed:', error);
      },
      complete: () => {
        this.isToolGuideDownloading = false;
      }
    });
  }
  ngOnInit() {
   
    this.sanitizedHTMLContent  = this.sanitizer.bypassSecurityTrustHtml(this.modifiedText);
  //  highlight(document.getElementById('old'),  document.getElementById('new'))
  // this.old = "Hello Anvesh";
  // this.mod = "Hello Rahul";

    const UserDetails = this.appToken.getLoginUserInfo();
    if (UserDetails != null) {
      this.UserName = UserDetails.EmpName;
      this.UserRole = UserDetails.Roles;
      this._global.userGPN = UserDetails.EmpGPN;
      this._global.userName = UserDetails.EmpName;
    }

    this._global.IsAdmin = false;
    this._global.IsTQApprover = false;
    this._global.IsTQLeader = false;
    this._global.IsEngTeam = false;

    this.IsLoadingResults = true;

    this._global.RolesList = this.appToken.GetRolesList();
    
    for (let index = 0; index < this._global.RolesList.length; index++) {
      if (this._global.RolesList[index] === Roles[Roles.Admin]) {
        this._global.CurrentRole = 'Admin';
        this._global.IsAdmin = true;
      }
      else if (this._global.RolesList[index] === Roles[Roles.TQApprover]) {
        this._global.CurrentRole = 'TQApprover';
        this._global.IsTQApprover = true;
      }
      else if (this._global.RolesList[index] === Roles[Roles.EngTeam]) {
        this._global.CurrentRole = 'EngTeam';
        this._global.IsEngTeam = true;
      }
      else if (this._global.RolesList[index] === Roles[Roles.TQLeader]) {
        this._global.CurrentRole = 'TQLeader';
        this._global.IsTQLeader = true;
      }
    this.IsLoadingResults = false;

   
    }

  }


  compare(){
    var oldText = this.old,     
    text = '';
this.mod.split('').forEach(function(val:any, i:any){
  if (val != oldText.charAt(i))
    text += "<span class='highlight'>"+val+"</span>";  
  else
    text += val;            
});
this.mod=text; 
  }
  Home(){
    this.route.navigate(['/home']);
  }
  logoutUser() {
    if (!confirm('Are you sure you want to log out of the application?')) {
      return;
    }
    window.location.href = environment.logoutUrl;
  }
  CreateGTCRequest(){
    this.route.navigate(['/home/createRequistion']);
  }
  
  AllRequisition(){
    this.route.navigate(['/home/AllRequisition']);

  }
  MyRequisition(){
    this.route.navigate(['/home/MyRequisition/1']);
  }
  ApprovedRequistion(){
    this.route.navigate(['/home/ApprovedRequistion/2']);
  }
  TQApproval(){
    this.route.navigate(['/home/TQTeamView/3']);

  }
  SpecialApproval(){

    this.route.navigate(['/home/TQLeaderView/4']);

  }
  AssignRoles(){
    this.route.navigate(['/home/RoleAssign']);

  }
  GTCReport(){
    this.route.navigate(['/home/Reports']);

  }
}
